<template>
    <b-form-group class="stripe-card-v2">
        <div class="payment-details">
            <b-row class="payment-header">
                <b-col cols="6">
                    Card Number
                </b-col>
                <b-col cols="4">
                    Expiration Date
                </b-col>
                <b-col cols="2">
                    CVC
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <div class="form-control">
                        <div id="card-number" :class="{ 'stripe-form-danger': cardNumberError }"
                             class="stripe-input"></div>
                        <b-form-invalid-feedback :state="!cardNumberError">
                            {{ cardNumberError }}
                        </b-form-invalid-feedback>
                    </div>
                </b-col>
                <b-col cols="4">
                    <div class="form-control">
                        <div id="card-expiry" :class="{ 'stripe-form-danger': cardExpiryError }"
                             class="stripe-input"></div>
                        <b-form-invalid-feedback :state="!cardExpiryError">
                            {{ cardExpiryError }}
                        </b-form-invalid-feedback>
                    </div>
                </b-col>
                <b-col cols="2">
                    <div class="form-control">
                        <div id="card-cvc" :class="{ 'stripe-form-danger': cardCvcError }" class="stripe-input"></div>
                        <b-form-invalid-feedback :state="!cardCvcError">
                            {{ cardCvcError }}
                        </b-form-invalid-feedback>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p v-if="stripeError" class="stripeError">
                        {{ stripeError }}
                    </p>
                </b-col>
            </b-row>
        </div>
        <b-row class="total-payment">
            <b-col cols="12">
                <p>Total: ${{ amount }}</p>
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
import "./StripeCard.scss";
import StripeService from '@services/stripe.service';
const style = {
    hideIcon: true,
    style: {
        base: {
            color: '#6C757D',
            backgroundColor: '#FFF',
            fontWeight: '400',
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '1.2rem',
            ':-webkit-autofill': {color: '#212529',},
            '::placeholder': {color: '#BABABA',},
        },
        invalid: {
            color: '#EA225B',
        },
    },
};
export default {
    name: 'StripeCardV2',
    props: {
        email: {
            type: String,
            required: true,
        },
        planName: {
            type: String,
            required: true,
        },
        amount: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
        },
        subscriptionPeriod: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        stripe: Stripe(window.env.STRIPE_PUBLISHABLE_KEY),
        elements: null,
        card: {
            cvc: '',
            number: '',
            expiry: ''
        },
        isInvalid: false,
        invalidFeedback: '',
        cardNumber: null,
        cardExpiry: '',
        cardCvc: '',
        stripeError: '',
        cardCvcError: '',
        cardExpiryError: '',
        cardNumberError: '',
    }),
    methods: {
        async sendPayment(isPublic = false) {
            this.isInvalid = false;
            this.invalidFeedback = '';
            return await this.stripe.createToken(this.cardNumber ?? this.card).then(async (result) => {
                try {
                    if (result.token) {
                        let stripeResponse = this.subscriptionPeriod
                            ? await StripeService.addSubscription({
                                token: result.token,
                                email: this.email,
                                planName: this.planName,
                                amount: this.amount,
                                period: this.subscriptionPeriod,
                            }, isPublic)
                            : await StripeService.sendPayment({
                                token: result.token.id,
                                email: this.email,
                                planName: this.planName,
                                amount: this.amount,
                            }, isPublic);
                        if (stripeResponse?.data?.error) {
                            this.isInvalid = true;
                            this.invalidFeedback = stripeResponse.data.error.message;
                        }
                        return stripeResponse;
                    } else if (!result || result.error) {
                        throw new Error(
                            !result
                                ? 'No response received from Stripe. Please try again later.'
                                : result.error
                        );
                    }
                } catch (error) {
                    this.isInvalid = true;
                    this.invalidFeedback = error.message;
                    throw error;
                }
            });
        },
        listenForErrors() {
            const vm = this;
            this.cardNumber.addEventListener('change', (event) => {
                vm.cardNumberError = event?.error?.message || '';
                vm.card.number = Boolean(event.complete);
                vm.toggleError('cardNumberError');
            });
            this.cardExpiry.addEventListener('change', (event) => {
                vm.cardExpiryError = event?.error?.message || '';
                vm.card.expiry = Boolean(event.complete);
                vm.toggleError('cardExpiryError');
            });
            this.cardCvc.addEventListener('change', (event) => {
                vm.cardCvcError = event?.error?.message || '';
                vm.card.cvc = Boolean(event.complete);
                vm.toggleError('cardCvcError');
            });
        },
        toggleError(fieldErrorName = null) {
            this.stripeError = (fieldErrorName ? this[fieldErrorName] : '') || this.cardNumberError || this.cardExpiryError || this.cardCvcError || '';
        },
    },
    mounted() {
        this.elements = this.stripe.elements();
        this.cardCvc = this.elements.create('cardCvc');
        this.cardExpiry = this.elements.create('cardExpiry');
        this.cardNumber = this.elements.create('cardNumber');
        this.cardCvc.mount('#card-cvc');
        this.cardExpiry.mount('#card-expiry');
        this.cardNumber.mount('#card-number');
        this.listenForErrors();
    },
}
</script>